module.exports = __webpack_public_path__ + "static/img/BLAKE-OUDSHOORN-BENNIER.5c5261e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLAKE-OUDSHOORN-BENNIER.jpg
// module id = atqE
// module chunks = 0